var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUartByteOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.06 122.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #97d3bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.03,0H7.03C3.14,0,0,3.15,0,7.04v83.63c0,3.89,3.14,7.04,7.03,7.04h144c3.88,0,7.03-3.15,7.03-7.04V7.04c0-3.89-3.15-7.04-7.03-7.04ZM153.48,87.84c0,3.88-3.15,7.03-7.04,7.03H11.62c-3.89,0-7.04-3.15-7.04-7.03V9.87c0-3.88,3.15-7.03,7.04-7.03h134.82c3.89,0,7.04,3.15,7.04,7.03v77.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.93,
    y: 97.71,
    width: 26.21,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.82,
    y: 118.4,
    width: 60.41,
    height: 4.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.93,
    y: 27.73,
    width: 42.34,
    height: 42.34,
    rx: 5.24,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.42,48.94s-.03-.06,0-.08c.53-.34,1.02-.73,1.46-1.17,1.48-1.48,2.4-3.51,2.44-5.75.08-4.66-4.01-8.48-8.68-8.48h-1.09s-.05-.02-.05-.05v-2.36s-.02-.05-.05-.05h-2.1s-.05.02-.05.05v2.36s-.02.05-.05.05h-1.83s-.05-.02-.05-.05v-2.36s-.02-.05-.05-.05h-2.1s-.05.02-.05.05v2.36s-.02.05-.05.05h-6.19s-.05.02-.05.05v2.37s.02.05.05.05h2.1s.05.02.05.05v25.84s-.02.05-.05.05h-2.1s-.05.02-.05.05v2.37s.02.05.05.05h6.19s.05.02.05.05v2.37s.02.05.05.05h2.1s.05-.02.05-.05v-2.37s.02-.05.05-.05h1.83s.05.02.05.05v2.37s.02.05.05.05h2.1s.05-.02.05-.05v-2.37s.02-.05.05-.05h1.43c2.3,0,4.39-.93,5.9-2.44,1.51-1.51,2.44-3.6,2.44-5.9,0-2.97-1.55-5.59-3.9-7.06ZM74.23,35.92h6.7c3.34,0,6.28,2.74,6.16,6.08-.05,1.54-.69,2.92-1.71,3.94-1.06,1.06-2.53,1.72-4.15,1.72h-6.99s-.05-.02-.05-.05v-11.63s.02-.05.05-.05ZM85.38,60.15c-1.06,1.06-2.53,1.71-4.15,1.71h-6.99s-.05-.02-.05-.05v-11.63s.02-.05.05-.05h6.69c3.33,0,6.26,2.72,6.16,6.05-.05,1.55-.69,2.95-1.71,3.98Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.28,
    y: 39.96,
    width: 12.53,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.28,
    y: 56.34,
    width: 12.53,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.28,
    y: 48.11,
    width: 15.24,
    height: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 111.53,
    cy: 40.71,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 115.6,
    cy: 48.86,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 111.53,
    cy: 57.09,
    r: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.43,
    y: 20.62,
    width: 12.53,
    height: 1.5,
    transform: "translate(50.33 93.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.81,
    y: 20.62,
    width: 12.53,
    height: 1.5,
    transform: "translate(66.71 109.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.24,
    y: 19.27,
    width: 15.24,
    height: 1.5,
    transform: "translate(59.83 99.88) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 71.7,
    cy: 16.38,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 79.85,
    cy: 12.32,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 88.08,
    cy: 16.38,
    r: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.25,
    y: 56.3,
    width: 12.53,
    height: 1.5,
    transform: "translate(103.03 114.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.25,
    y: 39.92,
    width: 12.53,
    height: 1.5,
    transform: "translate(103.03 81.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.55,
    y: 48.15,
    width: 15.24,
    height: 1.5,
    transform: "translate(100.33 97.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.53,
    cy: 57.05,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.46,
    cy: 48.9,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.53,
    cy: 40.67,
    r: 2.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.03,
    y: 75.59,
    width: 12.53,
    height: 1.5,
    transform: "translate(163.63 -10.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.65,
    y: 75.59,
    width: 12.53,
    height: 1.5,
    transform: "translate(147.25 5.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.52,
    y: 76.94,
    width: 15.24,
    height: 1.5,
    transform: "translate(156.83 -1.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 87.29,
    cy: 81.33,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 79.14,
    cy: 85.39,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.91,
    cy: 81.33,
    r: 2.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUartByteOrder);
export default __webpack_public_path__ + "static/media/uart-byte-order.520b12f84e7b524f54a7c6543d0d270a.svg";
export { ForwardRef as ReactComponent };